export default __webpack_public_path__ + "static/media/creating-medication-list.dbdcf887.svg";